module.exports = __webpack_public_path__ + "img/banner.98e5ddf3.jpg";